import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { ColDef } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import * as agGrid from 'ag-grid-community';
import { HistoryComponent } from '../history/history.component';
import { routes } from '../../../../shared/routes/routes';
import { ApiService } from '../../../../api.service';
import { CommonService } from '../../../../shared/common/common.service';
import { activeAmbulance } from '../../../../shared/models/models';
import { OnDestroy } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { param } from 'lightgallery/plugins/video/lg-video-utils';
import { PopupService } from '../../../../services/popup.service';

@Component({
  standalone: false,
  selector: 'app-ambulance',
  templateUrl: './ambulance.component.html',
  styleUrls: ['./ambulance.component.scss'],
})
export class AmbulanceComponent {
  showExclusivePopup: boolean = false;
  showNoPlanPopup: boolean = false;
  @ViewChild(HistoryComponent) HistoryComponent!: HistoryComponent;
  gridReady = false;
  gridOptions!: agGrid.GridOptions;
  public searchDataValue = '';
  public tooltipHideDelay = 2000;
  SerachedRow: number | undefined;
  selectedTabIndex = 0;
  private gridApi: any;
  private gridColumnApi: any;
  paginationPageSize = 10;
  pages: number[] = [];
  totalPages: number = 0;
  currentPage: number = 1;
  visiblePageCount = 5;
  totalRecords = 0;
  totalPage: number = 0;
  public tooltipShowDelay = 0;
  lastElementOfPage: number = 0;
  NoRecordsFound!: boolean;
  public routes = routes;
  public tableData: Array<activeAmbulance> = [];
  public totalTableData: Array<activeAmbulance> = [];
  startPage = 1;
  fromRecord = 0;
  toRecord = 0;
  userProfile: any = {};
  telemedicineFeature: any;
  // pagination variables
  public pageSize = 10;
  public serialNumberArray: Array<number> = [];
  public totalData = 0;
  showFilter = false;
  private paginationSubscription!: Subscription;
  recordListing: any = [];
  paging: number[] = [];
  dataSource!: MatTableDataSource<activeAmbulance>;
  dependentData: any = [];
  selected_id: any;
  showApologies: boolean = false;
  subDetail: any;
  currPage: number = 0;
  reportIdToDelete: any;
  showDeleteModal: boolean = false;
  showApology: boolean = false;
  private destroy$ = new Subject<void>();
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    sortable: true,
    filter: true,
    resizable: true,
  };
  rowData: any = [];
  historyVisible = true;
  showRejectPopup: boolean = false;
  rejectReasonValue: any;
  routeCoords!: [number, number][];

  colDefs: ColDef[] = [
    {
      headerName: 'S.NO',
      valueGetter: (params: any) => {
        const rowNode = params.node;
        const model = params.api.getModel();
        const allRows: any[] = [];
        model.forEachNodeAfterFilterAndSort((node: any) => {
          allRows.push(node);
        });
        const globalIndex = allRows.findIndex((node) => node === rowNode);
        return globalIndex + 1;
      },
      editable: false,
      resizable: false,
      filter: false,
      sortable: false,
      lockPosition: true,
      flex: 0.5,
      minWidth: 80,
    },
    {
      headerName: 'Patient Name',
      valueGetter: (params: any) => {
        const displayName = this.commonService.getDisplayName(
          params.data?.user,
        );
        return displayName || 'N/A';
      },
      editable: false,
      resizable: true,
      filter: true,
      cellStyle: { marginLeft: '-8px' },
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      flex: 1,
      minWidth: 130,
    },
    {
      headerName: 'Number',
      field: 'phone_number',
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: 'Pick-up',
      field: 'pickup_location',
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      flex: 1,
      minWidth: 140,

      valueFormatter: (params: any) => {
        const value = params.value?.trim();
        if (!value || value.toUpperCase() === 'N/A') {
          return 'N/A';
        }
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      },

      comparator: (a: string = '', b: string = '') =>
        a.toLowerCase().localeCompare(b.toLowerCase()),

      cellRenderer: (params: any) => {
        const text = params.value ?? '';
        return `<span title="${text}" style="color: #000 !important" class="pickup-cell">${text}</span>`;
      },
    },
    {
      headerName: 'Drop-off',
      field: 'dropoff_location',
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      valueFormatter: (params: any) => {
        const value = params.value?.trim();
        if (!value || value.toUpperCase() === 'N/A') {
          return 'N/A';
        }
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      },
      comparator: (a: string = '', b: string = '') =>
        a.toLowerCase().localeCompare(b.toLowerCase()),
      flex: 1,
      minWidth: 140,
      cellRenderer: (params: any) => {
        const text = params.value ?? '';
        return `<span title="${text}" style="color: #000 !important" class="pickup-cell">${text}</span>`;
      },
    },
    {
      headerName: 'Booking Id',
      field: 'ambulance_booking_id',
      editable: false,
      minWidth: 100,
      flex: 1,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
    },
    {
      headerName: 'Booking Date',
      valueGetter: (params: any) => {
        const rawDate = params.data?.booking_date;
        if (!rawDate) return 'N/A';
        const date = new Date(rawDate);
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      resizable: true,
      filter: true,
      cellStyle: { marginLeft: '-8px' },
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      flex: 1,
      minWidth: 140,
    },
    {
      headerName: 'Booking Time',
      valueGetter: (params: any) => {
        const rawDate = params.data?.booking_date;
        if (!rawDate) return 'N/A';
        const date = new Date(rawDate);
        return date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      cellStyle: { marginLeft: '-8px' },
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      flex: 1,
      minWidth: 140,
    },
    {
      headerName: 'Status',
      field: 'ride_status',
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      cellRenderer: (params: any) => {
        const status = params.data.ride_status?.toLowerCase();
        const statusIcons: Record<string, string> = {
          accepted: 'assets/img/ambulance/accepted.webp',
          completed: 'assets/img/ambulance/compelete.webp',
          new: 'assets/img/ambulance/New.webp',
          rejected: 'assets/img/ambulance/rejected.webp',
          'in review': 'assets/img/ambulance/inreview.webp',
          started: 'assets/img/ambulance/started.webp',
          expired: 'assets/img/ambulance/expired-icon.webp',
          trial: 'assets/img/ambulance/trial-icon.webp',
          'new via agent': 'assets/img/ambulance/new-via-agent-icon.webp',
        };
        const iconUrl = statusIcons[status];

        const container = document.createElement('span');
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.gap = '6px';
        container.title = params.value || status;

        if (status === 'rejected') {
          const infoIcon = document.createElement('img');
          infoIcon.src = 'assets/img/ambulance/reason_info.webp';
          infoIcon.alt = 'View rejection reason';
          infoIcon.style.width = '17px';
          infoIcon.style.height = '17px';
          infoIcon.style.cursor = 'pointer';
          infoIcon.title = 'Reason';

          infoIcon.onclick = (e) => {
            e.stopPropagation();
            this.displayRejectReason(params.data);
          };

          container.appendChild(infoIcon);
        }

        if (iconUrl) {
          const img = document.createElement('img');
          img.src = iconUrl;
          img.alt = status;
          img.style.width = '18px';
          img.style.height = '18px';
          container.appendChild(img);
        }

        const textSpan = document.createElement('span');
        textSpan.innerText = params.value || '';
        textSpan.style.textTransform = 'capitalize';
        textSpan.style.setProperty('color', 'black', 'important');
        container.appendChild(textSpan);

        return container;
      },
      flex: 1,
      minWidth: 140,
    },
    {
      headerName: 'Actions',
      width: 180,
      cellRenderer: () => {
        return `
      <div class="actions-cell">
        <button class="track-map-btn" title="Track Vehicle">
          <img src="assets/map.jpg" alt="Track Vehicle" />
        </button>
      </div>
    `;
      },
      onCellClicked: (params: any) => {
        const event = params.event as MouseEvent;
        const target = event.target as HTMLElement;

        const button = target.closest('.track-map-btn');
        if (!button) return;

        const bookingId = params.data.ambulance_booking_id;
        if (!bookingId) {
          console.error('ambulance_booking_id missing', params.data);
          return;
        }
        this.trackVehicle(bookingId);
      },
    },
  ];

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private http: HttpClient,
    public popupService: PopupService,
  ) {}

  reload(data: any) {
    this.historyVisible = false;
    this.getReports(this.userProfile.user_id);
    setTimeout(() => {
      this.historyVisible = true;
    }, 0);
  }
  ngOnInit() {
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    this.subDetail = JSON.parse(localStorage.getItem('subDetail') || '{}');

    this.getReports(this.userProfile.user_id);
    this.commonService.modalClosed$.subscribe((closed) => {
      if (closed) {
        this.getReports(
          this.selected_id ? this.selected_id : this.userProfile.user_id,
        );
        this.showApology = true;
        this.commonService.reset();
      }
    });
    this.getUserSubscription();
  }

  private getReports(id: any): void {
    this.spinner.show();
    this.apiService.getActivebookingAmbulnace(id).subscribe({
      next: (apiRes: any) => {
        this.rowData = apiRes.data
          ?.filter((item: any) => item?.ride_status !== 'COMPLETED')
          .map((item: any) => ({
            ambulance_booking_id: item.ambulance_booking_id ?? 'N/A',
            ambulance_id: item.ambulance_id ?? 'N/A',
            user_id: item.user_id ?? 'N/A',
            booking_date: item.booking_date ?? 'N/A',
            pickup_location: item.pickup_location ?? 'N/A',
            dropoff_location: item.dropoff_location ?? 'N/A',
            medical_condition: item.medical_condition ?? 'N/A',
            country_dial_code: item.country_dial_code ?? 'N/A',
            phone_number: item.phone_number ?? 'N/A',
            start_otp: item.start_otp ?? 'N/A',
            end_otp: item.end_otp ?? 'N/A',
            ride_status: item.ride_status ?? 'N/A',
            channel_id: item.channel_id ?? 'N/A',
            driver_name: item.driver_name ? item.driver_name : 'N/A',
            is_al_carte: item.is_al_carte ?? 'N/A',
            created_by_user_id: item.created_by_user_id ?? 'N/A',
            updated_by_user_id: item.updated_by_user_id ?? 'N/A',
            is_deleted: item.is_deleted ?? 'N/A',
            createdAt: item.createdAt ?? 'N/A',
            updatedAt: item.updatedAt ?? 'N/A',
            ambulance: item.ambulance ?? 'N/A',
            rejection_reason: item.rejection_reason ?? 'N/A',
            user: {
              first_name: item.user?.first_name ?? 'N/A',
              last_name: item.user?.last_name ?? 'N/A',
              phone: item.user?.phone ?? 'N/A',
              country_dial_code: item.user?.country_dial_code ?? 'N/A',
            },
          }));
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  deleteBooking() {
    this.spinner.show();
    this.apiService.CancelAmbulance(this.reportIdToDelete).subscribe({
      next: () => {
        const id = this.selected_id || this.userProfile.user_id;
        this.getReports(id);
        this.toastrService.success('Record deleted successfully');
        this.spinner.hide();
      },
      error: () => {
        this.toastrService.error('Error in deleting records');
        this.spinner.hide();
      },
    });
  }

  checkEnabledDisbaled() {
    return (
      JSON.parse(localStorage.getItem('user') || '{}').role === 'Dependent'
    );
  }

  getFormattedDobWithAge(dob: string): string {
    if (!dob || dob === '0000' || dob.trim() === '') {
      return '';
    }

    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const birthDate = new Date(dob);

    if (isNaN(birthDate.getTime()) || birthDate.getFullYear() === 1970) {
      return '';
    }

    const today = new Date();
    const day = birthDate.getDate();
    const month = months[birthDate.getMonth()];
    const year = birthDate.getFullYear();

    let age = today.getFullYear() - year;
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= day);

    if (!hasBirthdayPassed) {
      age -= 1;
    }

    return `${day} ${month} ${year}, ${age} years`;
  }
  onEdit(amublance: any): void {
    this.commonService.setEditData1(amublance);
  }

  getUserSubscription() {
    this.spinner.show();
    this.apiService.getUserSubscription().subscribe({
      next: (res: any) => {
        this.dependentData = [];
        const sub = res || {};
        this.telemedicineFeature = sub?.managePlanData?.find(
          (f: any) => f.feature_name === 'Road Ambulance',
        );

        this.dependentData = (sub?.dependentData || []).map((d: any) => ({
          name:
            d?.dependentUser?.full_name?.trim() ||
            `${d?.dependentUser?.first_name || ''} ${
              d?.dependentUser?.last_name || ''
            }`.trim(),
          id: d?.dependentUser?.user_id,
        }));

        sub.userData.full_name ||= `${sub.userData.first_name || ''} ${
          sub.userData.last_name || ''
        }`.trim();
        this.spinner.hide();
      },
      error: (err: any) => {
        console.error('Error fetching profile:', err);
        this.spinner.hide();
      },
    });
  }

  selectTab(index: number, id: any) {
    this.selectedTabIndex = index;
    this.selected_id = index === 0 ? 0 : id;
    this.tableData = [];
    const targetId =
      this.selected_id !== 0 ? this.selected_id : this.userProfile.user_id;
    this.getReports(targetId);
    this.HistoryComponent.getReports(targetId);
  }

  closeApology() {
    this.showApology = false;
  }

  checkEligibility() {
    const isProfileValid = this.commonService.validateMandatoryProfileFields(
      this.userProfile,
    );

    if (!isProfileValid) {
      return;
    }

    this.apiService
      .VerifyTentureStatus({
        feature_id: this.telemedicineFeature?.feature_id
          ? this.telemedicineFeature?.feature_id
          : 3,
        type: 'Ambulance',
        user_id: this.userProfile.user_id,
      })
      .subscribe(
        (res: any) => {
          localStorage.setItem(
            'consult_status',
            String(res?.sub_tenure_status),
          );
          localStorage.setItem('tenure_consult_status', JSON.stringify(res));
          if (res) {
            if (res.plan === undefined || res.plan === null) {
              this.showNoPlanPopup = true;
              this.showExclusivePopup = false;
              this.showApologies = false;
              return;
            } else if (res.plan.bundle_id === 1) {
              this.showExclusivePopup = true;
              this.showNoPlanPopup = false;
              this.showApologies = false;
              return;
            } else if (res.sub_tenure_status === false) {
              this.showApologies = true;
              this.showNoPlanPopup = false;
              this.showExclusivePopup = false;
              return;
            } else {
              setTimeout(() => {
                this.commonService.addAmbulanceModalClosed();
                document.getElementById('openAddTeleModal')?.click();
              }, 100);
            }
          } else {
            setTimeout(() => {
              this.commonService.addAmbulanceModalClosed();
              document.getElementById('openAddTeleModal')?.click();
            }, 100);
          }
        },
        () => {
          this.toastrService.error('Error checking eligibility');
        },
      );
  }

  openForm() {
    this.showExclusivePopup = false;
    this.showNoPlanPopup = false;
    this.showApologies = false;
    setTimeout(() => {
      this.commonService.addAmbulanceModalClosed();
      document.getElementById('openAddTeleModal')?.click();
    }, 100);
  }

  openDeleteConfirmation(reportId: any): void {
    this.reportIdToDelete = reportId;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.reportIdToDelete = null;
  }

  moveTosubcription() {
    this.router.navigate([routes.patientSubscription]);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  upgradePlan() {
    this.showExclusivePopup = false;
    this.showNoPlanPopup = false;
    this.showApologies = false;
    localStorage.removeItem('category');
    this.router.navigate([routes.patientSubscription]);
  }

  displayRejectReason(data: any) {
    this.rejectReasonValue = data.rejection_reason;
    this.showRejectPopup = true;
  }

  closeRejectReason() {
    this.showRejectPopup = false;
  }

  // map

  trackVehicle(bookingId: number) {
    this.closePopupOnTrackVehicle();

    this.spinner.show();
    this.apiService.getAmbulanceTrackerId(bookingId).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        this.popupService.setVehicleData(res.data);

        const [latStr, lngStr] = res.data.pickup_coordinates.split(',');
        this.popupService.userCoords = [parseFloat(lngStr), parseFloat(latStr)];

        const [latStrDrop, lngStrDrop] =
          res.data.dropoff_coordinates.split(',');
        this.popupService.dropCoords = [
          parseFloat(lngStrDrop),
          parseFloat(latStrDrop),
        ];

        if (!res.data.ambulance_id) {
          this.popupService.status = 'WAITING';
          this.openVehiclePopupForUnassignedAmb();
          return;
        }

        const trackerId = res.data.ambulance.ambulance_tracker_id;
        this.popupService.ambulanceName =
          res.data.ambulance.registration_number;
        this.popupService.ride_status = res.data.ride_status;
        this.popupService.pickAddress = res.data.pickup_location;
        this.popupService.dropAddress = res.data.dropoff_location;
        this.popupService.dropBuildingAddress = res.data.building_drop_location;

        this.openVehiclePopup(trackerId, bookingId);
      },
      error: () => this.spinner.hide(),
    });
  }

  openVehiclePopup(trackerId: any, bookingId: any) {
    this.popupService.popupStyle = {};
    this.popupService.showPopup = true;
    this.popupService.isMinimized = false;
    this.popupService.routeDuration = '';
    this.popupService.routeDistance = '';
    this.popupService.routeDrawn = false;

    setTimeout(() => {
      this.fetchInitialLocation(trackerId, bookingId);
    }, 0);
  }

  openVehiclePopupForUnassignedAmb() {
    this.popupService.popupStyle = {};
    this.popupService.showPopup = true;
    this.popupService.isMinimized = false;
    this.popupService.routeDuration = '';
    this.popupService.routeDistance = '';
    this.popupService.routeDrawn = false;

    setTimeout(() => {
      this.fetchInitialLocationForUnassignedAmb();
    }, 0);
  }

  fetchInitialLocation(trackerId: number, bookingId: any) {
    const payload = { tracker_id: trackerId };

    this.apiService
      .getVehicleLiveLocationEndpoints(payload)
      .subscribe((res: any) => {
        if (!res?.success || !res?.value) return;

        const { lat, lng, heading } = res.value;
        this.initMap(lng, lat);
        this.startPolling(trackerId, bookingId);
      });
  }

  fetchInitialLocationForUnassignedAmb() {
    this.initMapForUnassignedAmb();
  }

  initMap(lng: number, lat: number) {
    if (this.popupService?.map) {
      this.popupService.map.remove();
      this.popupService.map = undefined as any;
    }

    this.popupService.map = new mapboxgl.Map({
      container: 'vehicleMap',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: 11,
      accessToken: environment.mapboxToken,
    });

    this.popupService.map.addControl(new mapboxgl.NavigationControl());

    this.popupService.map.on('load', async () => {
      this.popupService.map.resize();
      this.updateVehicleMarker(lng, lat);
      await this.addUserMarker();

      if (
        !this.popupService.routeDrawn &&
        this.popupService.ride_status?.toLowerCase() === 'started' &&
        this.popupService.dropCoords
      ) {
        await this.addUserPickupMarker();
        this.drawRoute([lng, lat], this.popupService.dropCoords, true);
        this.popupService.routeDrawn = true;
        this.popupService.status = 'REACHING';
      } else {
        this.drawRoute([lng, lat], this.popupService.userCoords, true);
        this.popupService.routeDrawn = true;
        this.popupService.status = 'ON_THE_WAY';
      }
    });
  }

  initMapForUnassignedAmb() {
    if (this.popupService.map) {
      this.popupService.map.remove();
      this.popupService.map = undefined as any;
    }

    this.popupService.map = new mapboxgl.Map({
      container: 'vehicleMap',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: this.popupService?.userCoords,
      zoom: 11,
      accessToken: environment.mapboxToken,
    });

    this.popupService.map.addControl(new mapboxgl.NavigationControl());

    this.popupService.map.on('load', async () => {
      this.popupService.map.resize();

      await this.addUserMarker();
      await this.addUserDropMarker();

      this.drawRoute(
        this.popupService.userCoords,
        this.popupService.dropCoords,
        true,
      );
      this.popupService.routeDrawn = true;
    });
  }

  async addUserMarker() {
    const el = document.createElement('img');
    el.style.width = '40px';
    el.style.height = '40px';

    if (this.popupService.ride_status?.toLowerCase() === 'started') {
      el.src = 'assets/hospital.png';

      const dropAddress = await this.getAddressFromCoords(
        this.popupService.dropCoords,
      );

      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        closeOnClick: false,
      }).setHTML(`<strong>Drop Location</strong><br>${dropAddress}`);

      const marker = new mapboxgl.Marker({ element: el })
        .setLngLat(this.popupService.dropCoords)
        .setPopup(popup)
        .addTo(this.popupService.map);

      el.addEventListener('mouseenter', () =>
        popup.addTo(this.popupService.map),
      );
      el.addEventListener('mouseleave', () => popup.remove());

      this.popupService.userMarker = marker;
    } else {
      el.src = 'assets/user.png';

      const pickupAddress = await this.getAddressFromCoords(
        this.popupService.userCoords,
      );

      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        closeOnClick: false,
      }).setHTML(`<strong>Pickup Location</strong><br>${pickupAddress}`);

      const marker = new mapboxgl.Marker({ element: el })
        .setLngLat(this.popupService.userCoords)
        .setPopup(popup)
        .addTo(this.popupService.map);

      el.addEventListener('mouseenter', () =>
        popup.addTo(this.popupService.map),
      );
      el.addEventListener('mouseleave', () => popup.remove());

      this.popupService.userMarker = marker;
    }
  }

  async addUserPickupMarker() {
    const el = document.createElement('img');
    el.src = 'assets/pin.png';
    el.style.width = '40px';
    el.style.height = '40px';

    const pickAddress = await this.getAddressFromCoords(
      this.popupService.userCoords,
    );

    const popup = new mapboxgl.Popup({
      offset: 25,
      closeButton: false,
      closeOnClick: false,
    }).setHTML(`<strong>Pickup Location</strong><br>${pickAddress}`);

    const marker = new mapboxgl.Marker({ element: el })
      .setLngLat(this.popupService.userCoords)
      .setPopup(popup)
      .addTo(this.popupService.map);

    el.addEventListener('mouseenter', () => popup.addTo(this.popupService.map));
    el.addEventListener('mouseleave', () => popup.remove());

    this.popupService.userMarker = marker;
  }

  async addUserDropMarker() {
    const el = document.createElement('img');
    el.src = 'assets/hospital.png';
    el.style.width = '40px';
    el.style.height = '40px';

    const dropAddress = await this.getAddressFromCoords(
      this.popupService.dropCoords,
    );

    const popup = new mapboxgl.Popup({
      offset: 25,
      closeButton: false,
      closeOnClick: false,
    }).setHTML(`<strong>Drop Location</strong><br>${dropAddress}`);

    const marker = new mapboxgl.Marker({ element: el })
      .setLngLat(this.popupService.dropCoords)
      .setPopup(popup)
      .addTo(this.popupService.map);

    el.addEventListener('mouseenter', () => popup.addTo(this.popupService.map));
    el.addEventListener('mouseleave', () => popup.remove());

    this.popupService.userMarker = marker;
  }

  updateVehicleMarker(lng: number, lat: number) {
    if (!this.popupService.vehicleMarker) {
      const container = document.createElement('div');
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
      container.style.alignItems = 'center';

      const label = document.createElement('div');
      label.innerText = this.popupService.ambulanceName;
      label.style.background = '#fff';
      label.style.color = '#070202';
      label.style.fontSize = '12px';
      label.style.padding = '2px 6px';
      label.style.borderRadius = '4px';
      label.style.marginBottom = '4px';
      label.style.whiteSpace = 'nowrap';

      const img = document.createElement('img');
      img.src = 'assets/ambulance-new-img.png';
      img.style.width = '40px';
      img.style.height = '40px';

      container.appendChild(label);
      container.appendChild(img);

      this.popupService.vehicleMarker = new mapboxgl.Marker({
        element: container,
        // rotation: heading,
        rotationAlignment: 'map',
      })
        .setLngLat([lng, lat])
        .addTo(this.popupService.map);
    } else {
      this.popupService.vehicleMarker.setLngLat([lng, lat]);
      // this.popupService.vehicleMarker.setRotation(heading);
    }
  }

  startPolling(bookingId: number, trackerId: number) {
    this.popupService.liveInterval = setInterval(() => {
      this.checkRideStatus(bookingId, trackerId);
    }, 5000);
  }

  checkRideStatus(trackerId: number, bookingId: number) {
    this.apiService.getAmbulanceTrackerId(bookingId).subscribe({
      next: (res: any) => {
        const newStatus = res.data.ride_status?.toLowerCase();
        this.popupService.ride_status = newStatus;

        if (newStatus === 'completed') {
          this.closePopupOnEnd();
          this.popupService.showCompletedPopup = true;

          return;
        }

        this.fetchLiveLocation(trackerId);
      },
      error: (err) => {
        console.error('Status check failed', err);
      },
    });
  }

  closePopupOnEnd() {
    this.popupService.showPopup = false;
    this.popupService.isMinimized = false;
    this.popupService.routeDrawn = false;
    this.popupService.status = null;
    this.popupService.etaMinutes = '';
    this.popupService.popupStyle = {};

    if (this.popupService.liveInterval) {
      clearInterval(this.popupService.liveInterval);
      this.popupService.liveInterval = null;
    }

    if (this.popupService.map) {
      this.popupService.map.remove();
      this.popupService.map = undefined as any;
    }

    this.popupService.vehicleMarker = undefined as any;
  }

  fetchLiveLocation(trackerId: number) {
    const payload = { tracker_id: trackerId };

    this.apiService
      .getVehicleLiveLocationEndpoints(payload)
      .subscribe((res: any) => {
        if (!res?.success) return;

        const { lat, lng, heading } = res.value;

        this.updateVehicleMarker(lng, lat);
      });
  }

  closeAssignPopup() {
    this.popupService.showAssignPopup = false;
  }

  closeBlankDataPopup() {
    this.popupService.showBlankDataPopup = false;
  }

  drawRoute(from: [number, number], to: [number, number], isPrimary = false) {
    fetch(
      `https://api.mapbox.com/directions/v5/mapbox/driving/` +
        `${from[0]},${from[1]};${to[0]},${to[1]}` +
        `?geometries=geojson&overview=full&access_token=${environment.mapboxToken}`,
    )
      .then((res) => res.json())
      .then((data) => {
        if (!data?.routes?.length) return;

        const route = data.routes[0];

        const routeCoords: [number, number][] = route.geometry.coordinates;

        const routeFeature: GeoJSON.Feature<GeoJSON.LineString> = {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: routeCoords,
          },
          properties: {},
        };

        this.popupService.routeDuration =
          (route.duration / 60).toFixed(1) + ' mins';
        this.popupService.routeDistance =
          (route.distance / 1000).toFixed(2) + ' km';

        this.popupService.etaMinutes = this.popupService.routeDuration;

        if (this.popupService.map.getSource('route')) {
          this.popupService.map.removeLayer('route');
          this.popupService.map.removeSource('route');
        }

        this.popupService.map.addSource('route', {
          type: 'geojson',
          data: routeFeature,
        });

        this.popupService.map.addLayer({
          id: 'route',
          type: 'line',
          source: 'route',
          paint: {
            'line-color': '#1db7dd',
            'line-width': 5,
            'line-opacity': isPrimary ? 1 : 0.5,
          },
        });

        if (isPrimary) {
          this.fitBounds(routeCoords);
          this.addRouteLabel(routeCoords);
        }
      });
  }

  fitBounds(coordinates: [number, number][]) {
    const bounds = new mapboxgl.LngLatBounds();

    coordinates.forEach((coord) => bounds.extend(coord));

    this.popupService.map.fitBounds(bounds, { padding: 60 });
  }

  addRouteLabel(coords: [number, number][]) {
    const midIndex = Math.floor(coords.length / 2);

    new mapboxgl.Popup({ closeOnClick: false })
      .setLngLat(coords[midIndex])
      .setHTML(
        `
        <strong>${this.popupService.routeDistance}</strong><br/>
        ⏱ ${this.popupService.routeDuration}`,
      )
      .addTo(this.popupService.map);
  }

  closePopupOnTrackVehicle() {
    this.popupService.showPopup = false;
    this.popupService.isMinimized = false;
    this.popupService.routeDrawn = false;

    this.popupService.status = null;
    this.popupService.etaMinutes = '';
    this.popupService.popupStyle = {};

    if (this.popupService.liveInterval) {
      clearInterval(this.popupService.liveInterval);
      this.popupService.liveInterval = null;
    }

    if (this.popupService.map) {
      this.popupService.map.remove();
      this.popupService.map = undefined as any;
    }

    this.popupService.vehicleMarker = undefined as any;
  }

  async getAddressFromCoords(coords: number[]): Promise<string> {
    try {
      const [lng, lat] = coords;

      const res = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${environment.mapboxToken}`,
      );

      const data = await res.json();
      return data?.features?.[0]?.place_name || 'Location not found';
    } catch (error) {
      console.error('Geocoding error:', error);
      return 'Location not found';
    }
  }
}
